const state = () => ({
  showCookiesSettings: false,
  showCookiesDialog: false,
  showCookiesDocument: false,
  cookiesSettings: {},
  consentList: [
    {
      switch: {
        disabled: true
      },
      identifier: 'technical',
      disabled: true,
      dataCy: `technicalCookiesButton`,
      dataCyRow: `technicalCookiesRow`,
      dataCyBodyText: `technicalCookiesBodyText`
    },
    {
      switch: true,
      identifier: 'functional',
      disabled: false,
      dataCy: `funcionalCookiesButton`,
      dataCyRow: `functionalCookiesRow`,
      dataCyBodyText: `functionalCookiesBodyText`
    },
    {
      switch: true,
      identifier: 'analytics',
      disabled: false,
      dataCy: `analyticsCookiesButton`,
      dataCyRow: `analyticsCookiesRow`,
      dataCyBodyText: `analyticsCookiesBodyText`
    },
    {
      switch: true,
      identifier: 'marketing',
      disabled: false,
      dataCy: `marketingCookiesButton`,
      dataCyRow: `marketingCookiesRow`,
      dataCyBodyText: `marketingCookiesBodyText`
    }
  ]
});

const getters = {
  showCookiesSettings(state) {
    return state.showCookiesSettings;
  },
  showCookiesDialog(state) {
    return state.showCookiesDialog;
  },
  showCookiesDocument(state) {
    return state.showCookiesDocument;
  },
  cookiesSettings(state) {
    return state.cookiesSettings;
  },
  consentList(state) {
    return state.consentList;
  }
};

const mutations = {
  setShowCookiesSettings(state, payload) {
    state.showCookiesSettings = payload;
  },
  setShowCookiesDocument(state, payload) {
    state.showCookiesDocument = payload;
  },
  setCookiesSettings(state, payload) {
    state.cookiesSettings = payload;
  },
  setConsentList(state, payload) {
    state.consentList = payload;
  },
  setShowCookiesDialog(state, payload) {
    state.showCookiesDialog = payload;
  }
};

const actions = {
  setCookiesSettings({ commit }, payload) {
    commit('setCookiesSettings', payload);
  },
  setShowCookiesSettings({ commit }, payload) {
    commit('setShowCookiesSettings', payload);
  },
  setShowCookiesDialog({ commit }, payload) {
    commit('setShowCookiesDialog', payload);
  }
};

export const cookiesConsent = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
